import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';

import LogoutButton from './LogoutButton';

const LogoutUserSessions = ({ logout, clicked, children, text }) => {
  const buttonText = text || t('admin:logout_user_sessions.button_text');
  
  return (
    typeof children === 'function'
      ? children({ logout, clicked, text: buttonText })
      : React.cloneElement(children, { logout, clicked, text: buttonText })
  );
};

LogoutUserSessions.propTypes = {
  text: PropTypes.string,
  logout: PropTypes.func.isRequired,
  clicked: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
  ]),
};

LogoutUserSessions.defaultProps = {
  children: LogoutButton,
  text: null,
};

export default LogoutUserSessions;
